/**
 * 阻止事件冒泡
 * Created by slipkinem on 2018/8/21 at 下午3:03.
 */
export const prevent = (e: Event): void => {
  e.stopPropagation();
  e.preventDefault();
};
